module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', [_c('p', {
    staticClass: "epi_head",
    attrs: {
      "id": "epi"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062973368_Contents#repi"
    }
  }, [_c('b', [_vm._v("Epigraph")])])])]), _vm._v(" "), _c('p', {
    staticClass: "epi_para"
  }, [_c('i', [_vm._v("If there is no struggle, there is no progress.")])]), _vm._v(" "), _c('p', {
    staticClass: "epi_rt"
  }, [_vm._v("—FREDERICK DOUGLASS,")]), _vm._v(" "), _c('p', {
    staticClass: "epi_rt_1"
  }, [_vm._v("WEST INDIA EMANCIPATION SPEECH, 1857")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17fc2c18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062973368_Epigraph.vue
// module id = 66
// module chunks = 0